import { Redacted, Schema } from "effect";
import { privateDependencyFailure } from "@workerstation/shared/errors/private-cause";

export const EditorRevealRequest = Schema.Union([
  Schema.Struct({ _tag: Schema.Literal("Line"), file: Schema.String, line: Schema.Number }),
  Schema.Struct({ _tag: Schema.Literal("Match"), file: Schema.String, line: Schema.Number, start: Schema.Number, end: Schema.Number })
]);
export type EditorRevealRequest = typeof EditorRevealRequest.Type;
export class EditorRevealFailure extends privateDependencyFailure<EditorRevealFailure>()("EditorRevealFailure", "editor reveal") {}
export const editorRevealFailure = (cause: unknown) => new EditorRevealFailure({ cause: Redacted.make(cause) });
export interface EditorRevealIdentity {
  readonly workspaceId: string | null;
  readonly scope: object;
}
export interface EditorRevealRange {
  readonly startLineNumber: number;
  readonly startColumn: number;
  readonly endLineNumber: number;
  readonly endColumn: number;
}
export interface EditorRevealTarget {
  readonly setPosition: (position: { readonly lineNumber: number; readonly column: number }) => void;
  readonly revealLineInCenter: (line: number) => void;
  readonly setSelection: (range: EditorRevealRange) => void;
  readonly revealRangeInCenter: (range: EditorRevealRange) => void;
  readonly focus: () => void;
}
export interface EditorRevealBindings {
  readonly current: () => EditorRevealIdentity;
  readonly openFile: (file: string) => void;
  readonly findEditor: (tabId: string) => EditorRevealTarget | undefined;
}
